export default __webpack_public_path__ + "ui/assets/img/compare-20.svg";